import { Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { CdkDrag } from '@angular/cdk/drag-drop';
import {ComponentEntity} from "../../../entities/component-entity";
import { getAlignmentText} from "../../../commons/compontents-utils";
import {CommonsUI, ROUTER_VIEW} from '../../../commons/constans';
import {PositionDirective} from "../../../directives/position.directive";
import {Router} from "@angular/router";
import {ClickComponentDirective} from "../../../directives/click-component.directive";
import {defaultComponentEntity} from "../../../commons/defaults-components";


@Component({
  selector: 'lib-app-button',
  standalone: true,
  imports: [
    CommonModule,
    PositionDirective,
    ClickComponentDirective,
  ],
  templateUrl: './button.component.html',
  styleUrl: './button.component.css',
})
export class ButtonComponent {
  component = input<ComponentEntity>(defaultComponentEntity());
  protected readonly CommonsUI = CommonsUI;
  constructor( private router: Router) {}
  protected readonly getAlignmentText = getAlignmentText;
}
